import Sections from './sections';
import CashbackToggle from './CashbackToggle';
import CheckoutThreshold from './CheckoutThreshold';
import OrderInfo from './OrderInfo';
import OrderMethodInfo from './OrderMethodInfo';
import PromoCodeInput from './PromoCodeInput';
import Tips from './Tips';

export default {
  Sections,
  CashbackToggle,
  CheckoutThreshold,
  OrderInfo,
  OrderMethodInfo,
  PromoCodeInput,
  Tips,
};
